import React from 'react';
import clsx from 'clsx';

import styles from './Modal.module.scss';
import FloatingToggleButton from './FloatingToggleButton';
import Icon from './Icon';

export default function Modal({ show, onClose, modalClassName, ...rest }) {
	return show ? (
		<div className={styles.root}>
			<div className={clsx(styles.modal, modalClassName)}>
				{rest.children}

				<FloatingToggleButton
					show={true}
					enabled={true}
					icon={<Icon icon="icon/close_blue.png" size="small" />}
					onClick={onClose}
					className={styles.closeButton}
				/>
			</div>
		</div>
	) : null;
}
